// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"clinical-portal-3__AddressInput__fieldset","half":"clinical-portal-3__AddressInput__half"};